import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

import Home from './pages/Home'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Terms from './pages/Terms'
import { OverlayScrollbar } from './components/OverlayScrollbar'

const App: React.FC = () => {
  useEffect(() => {
    const firebaseConfig = {
      apiKey: 'AIzaSyAQysLdfnBMLT6l4LIhyZUG0neGFS305sM',
      authDomain: 'stl-p-services.firebaseapp.com',
      projectId: 'stl-p-services',
      storageBucket: 'stl-p-services.appspot.com',
      messagingSenderId: '716559724965',
      appId: '1:716559724965:web:733a7c4001d1ec6697b84c',
      measurementId: 'G-01C0VMG991',
    }

    const app = initializeApp(firebaseConfig)
    getAnalytics(app)
  }, [])

  return (
    <>
      <OverlayScrollbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </>
  )
}

export default App
